import { useState } from "react";
import Webhooks from "./WebhooksV2";
import { TransferAgents } from "../TransferSettings/TransferAgents";
import { ParentLayout } from "./components/ParentLayout";
import { SectionLayout } from "./components/SectionLayout";
import { MainLayout } from "./components/MainLayout";
import { SectionItem } from "./components/SectionItem";
import RealTimeBookings from "./RealTimeBookingsV2";
import { CRMSearchEnabled } from "../RAG/CRMSearchV2/CRMSearch";
import { Extractions } from "./ExtractionV2/Extractions";
import { ToolIcons } from "./VoiceAssistantTools";

enum TOOL {
  WEBHOOKS = "Webhooks",
  EXTRACTION = "Extraction",
  TRANSFER_AGENTS = "Transfer Agents",
  CALENDAR_APPOINTMENTS = "Calendar Appointments",
  CONTACTS_SEARCH = "Contacts Search",
}

const ToolComponent = {
  [TOOL.WEBHOOKS]: (props) => <Webhooks {...props} />,
  [TOOL.EXTRACTION]: (props) => <Extractions {...props} />,
  [TOOL.TRANSFER_AGENTS]: (props) => <TransferAgents {...props} />,
  [TOOL.CALENDAR_APPOINTMENTS]: (props) => <RealTimeBookings {...props} />,
  [TOOL.CONTACTS_SEARCH]: (props) => <CRMSearchEnabled {...props} />,
};

function SmsAssistantTools(props) {
  const [activeTool, setActiveTool] = useState(TOOL.WEBHOOKS);

  const tools = Object.values(TOOL).reduce((acc, tool) => {
    return [...acc, { name: tool, href: "#", current: tool === activeTool }];
  }, []);

  return (
    <ParentLayout>
      <SectionLayout>
        {tools.map((tool) => (
          <SectionItem
            sectionName={tool.name}
            isActive={tool.current}
            icon={ToolIcons[tool.name]}
            onSectionClick={() => setActiveTool(tool.name)}
          />
        ))}
      </SectionLayout>
      <MainLayout>
        {ToolComponent[activeTool]({
          ...props,
        })}
      </MainLayout>
    </ParentLayout>
  );
}

export { SmsAssistantTools };
